/* eslint-disable max-lines-per-function */

import { commonTranslationKeys } from '@dreryk/react-common';
import {
   ButtonVariant,
   Modal,
   ModalCancelButton,
   ModalCloseButton,
   ModalConfirmButton,
   ModalWidth,
} from '@dreryk/react-components';

import { medicalServiceTranslationKeys } from '../../translations';

import { MedicalServiceCreateForm } from './MedicalServiceCreateForm';
import { MedicalServiceCreateFormLoader } from './MedicalServiceCreateForm.loader';
import { MedicalServiceCreateAction } from './MedicalServiceCreateModal.actions';

type MedicalServiceCreateModalProps = {
   readonly closeModal: VoidFunction;
   readonly onSuccess: VoidFunction;
};

export const MedicalServiceCreateModal = (props: MedicalServiceCreateModalProps): JSX.Element => {
   return (
      <Modal
         testId={'medicalServiceCreate'}
         title={medicalServiceTranslationKeys.create.modal.title}
         width={ModalWidth.HUGE}
      >
         <MedicalServiceCreateFormLoader>
            {({ practitioners, taxRates, fiscalPrintEnabled }) => (
               <MedicalServiceCreateForm
                  practitioners={practitioners}
                  taxRates={taxRates}
                  fiscalPrintEnabled={fiscalPrintEnabled}
               >
                  {({ handleSubmit, formState, reset, setNotUniqueMedicalServiceNameError }) => (
                     <>
                        <MedicalServiceCreateAction
                           onSuccess={reset}
                           onMedicalServiceAlreadyExistsFault={setNotUniqueMedicalServiceNameError}
                        >
                           {({ createMedicalService }) => (
                              <ModalConfirmButton
                                 label={medicalServiceTranslationKeys.create.modal.confirmAndCreateNext}
                                 onClick={handleSubmit(createMedicalService)}
                                 variant={ButtonVariant.SECONDARY}
                                 testId={'confirmAndCreateNext'}
                              />
                           )}
                        </MedicalServiceCreateAction>
                        <MedicalServiceCreateAction
                           onSuccess={props.onSuccess}
                           onMedicalServiceAlreadyExistsFault={setNotUniqueMedicalServiceNameError}
                        >
                           {({ createMedicalService }) => (
                              <ModalConfirmButton
                                 label={medicalServiceTranslationKeys.create.modal.confirm}
                                 onClick={handleSubmit(createMedicalService)}
                                 variant={ButtonVariant.PRIMARY}
                              />
                           )}
                        </MedicalServiceCreateAction>
                        <ModalCancelButton
                           label={commonTranslationKeys.cancel}
                           onClick={props.closeModal}
                           shouldConfirmExit={formState.isDirty}
                        />
                        <ModalCloseButton onClick={props.closeModal} shouldConfirmExit={formState.isDirty} />
                     </>
                  )}
               </MedicalServiceCreateForm>
            )}
         </MedicalServiceCreateFormLoader>
      </Modal>
   );
};
